import styled from 'styled-components';

export const MarathonNameBlock = styled.div`
  width: 80%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  //   margin: 0px auto;
  //   padding-left: 40px;
  margin-top: 40px;
  margin-bottom: 40px;
`;
export const Label = styled.label`
  min-width: 150px;
  font-size: 20px;
  cursor: pointer;
  margin-bottom: 10px;
`;
export const CreateButton = styled.div`
  width: 50%;
  margin-left: 10px;
`;
export const ItemBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 10px 10px 0;
  width: 70%;
`;
export const DateBlock = styled.div`
  display: flex;
  //   width: 300px;
  width: 40%;
  justify-content: space-between;
  align-items: center;
  margin-right: 50px;
`;

export const Content = styled.div`
  width: 70%;
  margin: 0px auto;
  //   flex-direction: column;
  //   justify-content: space-between;
  align-items: center;
  padding-left: 50px;
  // margin-bottom: 40px;
  padding-bottom: 40px;
`;
export const Block = styled.div`
  display: flex;
  flex-direction: row;
  // justify-content: flex-end;
`;

export const LinkBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  width: 100%;
`;
export const SecondLinkBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ButtonBlock = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  height: 45px;
  padding: 5px 0 5px 0;
`;

export const H1 = styled.h1`
  text-align: left;
  font-size: 20px;
  margin-top: 40px;
  //   padding-left: 50px;
  margin-left: 70px;
`;
export const FooterBlock = styled.div`
  height: 50px;
`;

export const Buttons = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0px auto;
  margin-top: 65px;
  width: 60%;
`;
export const H2 = styled.label`
  min-width: 50px;
  font-size: 15px;
  cursor: pointer;
  //   margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/MarathonPage/MarathonStyles.js